<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-form ref="detailForm" :model="detail" :rules="rules" label-width="150px" :label-position="device === 'mobile' ? 'top' : 'right'">
      <el-collapse v-model="activeCollapses" class="el-card-collapse">
        <el-collapse-item title="基本信息" name="Basic">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="16">
              <el-form-item label="商品名称" prop="goodsName">
                <el-input v-model.trim="detail.goodsName" placeholder="请输入商品名称" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="商品单位">
                <el-input v-model.trim="detail.goodsUnit" class="max-width" placeholder="件/箱/个/盒 等" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="所属品牌">
                <el-select v-model="detail.brandId" placeholder="请选择所属品牌" clearable>
                  <el-option v-for="(item, index) in brands" :key="index" :label="item.brandName" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="所属分类">
                <el-select v-model="detail.categoryId" placeholder="请选择所属分类" clearable>
                  <el-option-group v-for="group in categories" :key="group.name" :label="group.name">
                    <el-option v-for="item in group.children" :key="item.id" :label="item.name" :value="item.id" />
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="显示排序">
                <el-input v-model="detail.sortBy" class="max-width" placeholder="商品在前端的排序" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="16">
              <el-form-item class="inline-form-item" label="供应商">
                <el-select v-model="detail.supplierId" filterable placeholder="请选择供应商" clearable>
                  <el-option v-for="(item, index) in suppliers" :key="index" :label="item.supplierName" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="商品图片" prop="cover">
                <div class="image-uploader">
                  <el-upload
                    action="#"
                    accept="image/*"
                    class="avatar-uploader"
                    :show-file-list="false"
                    :on-change="imageChange.bind(null, { key: 'cover' })"
                    :http-request="imageUpload.bind(null, { key: 'cover' })"
                  >
                    <template v-if="coverImage.url">
                      <img :src="coverImage.url" class="avatar">
                      <div class="el-upload-img-actions">
                        <span class="el-upload-img-preview" @click.stop="imagePreview({ key: 'cover' })">
                          <i class="el-icon-zoom-in" />
                        </span>
                        <span class="el-upload-img-delete" @click.stop="imageBeforeRemove({ key: 'cover' })">
                          <i class="el-icon-delete" />
                        </span>
                      </div>
                    </template>
                    <i v-else class="el-icon-plus avatar-uploader-icon" />
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="16">
              <el-form-item label="商品轮播图" prop="galleries">
                <el-upload
                  action="#"
                  :limit="9"
                  multiple
                  accept="image/*"
                  list-type="picture-card"
                  :file-list="galleries"
                  :on-change="imageChange.bind(null, { key: 'galleries' })"
                  :on-remove="imageRemove.bind(null, { key: 'galleries' })"
                  :on-preview="imagePreview.bind(null, { key: 'galleries' })"
                  :http-request="imageUpload.bind(null, { key: 'galleries' })"
                  :before-remove="imageBeforeRemove.bind(null, { key: 'galleries' })"
                >
                  <i class="el-icon-plus" />
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="6">
              <el-form-item class="inline-form-item" label="新品">
                <el-switch v-model="detail.isNew" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item class="inline-form-item" label="推荐">
                <el-switch v-model="detail.isHot" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item class="inline-form-item" label="上架">
                <el-switch v-model="detail.isOnsale" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="商品价格" name="Prices">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="供货价" prop="stockPrice">
                <el-input v-model="detail.stockPrice" type="number" class="max-width" placeholder="请输入供货价">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="成本价" prop="costPrice">
                <el-input v-model="detail.costPrice" type="number" class="max-width" placeholder="请输入成本价">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="兑换积分" prop="point">
                <el-input v-model="detail.point" type="number" class="max-width" placeholder="请输入积分数" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="配送费用" prop="freightPrice">
                <el-input v-model="detail.freightPrice" type="number" class="max-width" placeholder="请输入配送费用">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="商品库存" prop="quantity">
                <el-input v-model="detail.quantity" type="number" class="max-width" placeholder="请输入商品库存量" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item name="Promotion">
          <template slot="title">
            <span>营销管理</span>
            <el-button type="primary" icon="el-icon-plus" size="mini" style="margin-left: 20px;" @click.stop="addPromotion">增加营销设置</el-button>
          </template>
          <promo-table :list.sync="detail.promotions" @edit="handleModify" />
        </el-collapse-item>

        <el-collapse-item title="商品介绍" name="Introduction">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="planText">
                <my-editor v-model="detail.intro" :text.sync="detail.planText" :images.sync="editorImages" :not-exists.sync="deletedImages" :auto-focus="false" @change="editorChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="商品规格" name="Specification" style="display: none">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="商品名称">
                <el-input placeholder="请输入商品名称" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="商品名称">
                <el-input placeholder="请输入商品名称" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
      <el-image ref="elImage" style="width: 0; height: 0;" :src="previewImg" :preview-src-list="previewList" />
    </el-form>

    <div class="app-form-button-group">
      <el-button icon="el-icon-back" @click="onBack">返回列表</el-button>
      <el-button type="info" @click="onCreateGoods">新增商品</el-button>
      <el-button type="primary" @click="onSubmit">提交保存</el-button>
    </div>

    <el-dialog :title="promoDialogTitle" :visible.sync="promoDialogVisible" :fullscreen="device==='mobile'">
      <el-form ref="promoForm" :model="promotion" :rules="promoRules" label-width="100px" :label-position="device === 'mobile' ? 'top' : 'right'">
        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <el-form-item class="inline-form-item" label="限购">
              <el-switch v-model="promotion.isLimited" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item class="inline-form-item" label="限购数量" prop="quota">
              <el-input v-model="promotion.quota" type="number" class="max-width" placeholder="请输入限购数量" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <el-form-item class="inline-form-item" label="促销数量" prop="quantity">
              <el-input v-model="promotion.quantity" type="number" class="max-width" placeholder="请输入促销数量" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item class="inline-form-item" label="促销价" prop="retailPrice">
              <el-input v-model="promotion.retailPrice" type="number" class="max-width" placeholder="请输入促销价" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <el-form-item class="inline-form-item" label="开始日期">
              <el-date-picker v-model="promotion.startDate" type="date" value-format="yyyy-MM-dd" class="max-width" placeholder="选择开始日期" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item class="inline-form-item" label="结束日期" prop="endDate">
              <el-date-picker v-model="promotion.endDate" type="date" value-format="yyyy-MM-dd" class="max-width" placeholder="选择结束日期" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="inline-form-item" label="发货提示">
              <el-input v-model="promotion.deliveryTip" placeholder="请输入发货提示" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template slot="footer">
        <el-button @click.native="promoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmit">确定提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadFile } from '@/api/oss'
import { saveGoods, getDetail } from '@/api/goods'

export default {
  name: 'GoodsDetail',
  components: {
    MyEditor: () => import('@/components/MyEditor'),
    PromoTable: () => import('@/components/PromoTable')
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkCover = (rule, value, callback) => {
      if (!this.coverImage || !this.coverImage.url) {
        return callback('请上传商品图片')
      } else {
        callback()
      }
    }
    const checkGalleries = (rule, value, callback) => {
      if (!this.galleries || this.galleries.length === 0) {
        return callback('请至少上传一张轮播图片')
      } else {
        callback()
      }
    }
    const validateDate = (rule, value, callback) => {
      if (this.promotion.endDate) {
        const nowTime = new Date().getTime()
        const endTime = new Date(this.promotion.endDate).getTime()
        if (endTime < nowTime) {
          return callback('结束日期不能小于今天')
        } else if (this.promotion.startDate) {
          const startTime = new Date(this.promotion.startDate).getTime()
          if (startTime > endTime) return callback('结束日期不能小于开始日期')
        }
      }
      callback()
    }

    return {
      loading: false,
      detail: {},
      promotion: {},
      previewImg: '',
      previewList: [],
      galleries: [],
      editorImages: [],
      deletedImages: [],
      coverImage: { url: '', file: undefined },
      activeCollapses: ['Basic', 'Prices', 'Promotion', 'Introduction', 'Specification'],
      rules: {
        goodsName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        point: [{ required: true, message: '请输入积分数', trigger: 'blur' }],
        quantity: [{ required: true, message: '请输入库存量', trigger: 'blur' }],
        freightPrice: [{ required: true, message: '请输入配送费用', trigger: 'blur' }],
        stockPrice: [{ required: true, message: '请输入供货价', trigger: 'blur' }],
        costPrice: [{ required: true, message: '请输入成本价', trigger: 'blur' }],
        cover: [{ required: true, validator: checkCover, trigger: 'change' }],
        galleries: [{ required: true, validator: checkGalleries, trigger: 'change' }],
        planText: [{ required: true, message: '请输入商品详情介绍', trigger: 'change' }]
      },
      promoRules: {
        quota: [{ required: true, message: '请输入限购数量', trigger: 'blur' }],
        quantity: [{ required: true, message: '请输入促销库存量', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入促销价', trigger: 'blur' }],
        endDate: [{ validator: validateDate, trigger: 'blur' }]
      },
      promoDialogTitle: '',
      promoDialogVisible: false
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device,
      categories: state => {
        return state.base.categoryList.filter(item => item.mallType === 1)
      },
      suppliers: state => state.base.supplierList,
      brands: state => state.base.brandList
    })
  },
  watch: {
    // 进货价（供货价）
    'detail.stockPrice': {
      handler(newPrice) {
        const stockPrice = parseFloat(newPrice)
        if (this.detail && !isNaN(stockPrice)) {
          const newCostPrice = stockPrice * 110 / 100
          const oldCostPrice = parseFloat(this.detail.costPrice)
          if (isNaN(oldCostPrice) || newCostPrice > oldCostPrice) {
            // 成本价 = 进货价 x 110%
            this.detail.costPrice = this.$util.formatNumber(newCostPrice, 2, '')
          }
        }
      }
    }
  },
  created() {
    if (!this.isCreate) {
      const goodsId = this.$route.query.id || undefined
      if (goodsId) this.fetchData(goodsId)
    } else {
      this.init()
    }
  },
  methods: {
    init() {
      this.loading = true
      this.detail = {
        brandId: '',      // 品牌ID
        categoryId: '',   // 分类ID
        goodsName: '',    // 商品名称
        goodsUnit: '',    // 商品单位（件、个、盒等）
        cover: '',        // 封面图片
        intro: '',        // 商品详情（带有html标签）
        planText: '',     // 商品详情（不带html标签）
        stockPrice: 0,    // 供货价（厂家供货价）
        costPrice: 0,     // 成本价（供货价ｘ110%＋物流＋包装）
        retailPrice: 0,   // 零售价（成本价＋利润）
        freightPrice: 0,  // 配送费用
        specialPrice: 0,  // 特价
        point: 0,         // 积分
        pointPrice: 0,    // 使用积分时的售价
        coupon: 0,        // 消费券
        couponPrice: 0,   // 使用消费券时的售价
        quantity: 0,      // 库存
        isOnsale: 1,      // 状态（0 下架 1 上架）
        mallType: 1,      // 销售位置（1 积分商城 2 优品商城 3 福利商城）
        priceType: 1,     // 价格类型：0 纯现金，现金+积分，现金+券 1 纯积分 2 现金+积分 3 现金+券 4 积分+券 5 现金+积分，现金+券
        isNew: 0,         // 是否新品（1 可以在新品首发页面展示）
        isHot: 0,         // 是否人气推荐（1 在人气推荐页面展示）
        galleries: [],    // 商品图片画廊
        products: [],     // 商品规格单品
        supplierId: '',   // 供应商ID
        surprise: 0,      // 购物惊喜值倍数
        sortBy: 999,      // 前端显示排序
        promotions: []    // 促销设置
      }
      this.galleries = []
      this.editorImages = []
      this.deletedImages = []
      this.coverImage = { url: '', file: undefined }
      this.$util.delay(500).then(() => { this.loading = false })
    },
    fetchData(goodsId) {
      this.loading = true
      getDetail(goodsId).then(goods => {
        const images = this.$util.getElementsByType(goods.intro, 'img')
        this.editorImages = images.map(img => ({ url: img.src, old: img.src, file: undefined }))
        this.galleries = goods.galleries.map(item => ({ url: item, file: undefined }))
        this.coverImage = Object.assign({}, { url: goods.cover, file: undefined })
        this.deletedImages = []
        this.detail = goods
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false })
      })
    },
    imageChange(obj, file, files) {
      if (!file) return false

      const isImage = `${file.raw.type}`.startsWith('image/')
      if (!isImage) return this.$message.warning('上传的文件必须是图片')

      if (obj.key === 'cover') {
        this.coverImage.url = URL.createObjectURL(file.raw)
        this.$refs.detailForm.validateField('cover')
      } else {
        const images = files.map(image => {
          const index = this.galleries.findIndex(item => item.uid === image.uid)
          return { uid: image.uid, url: image.url, file: index >= 0 ? this.galleries[index].file : undefined }
        })
        this.galleries = [...images]
        this.$refs.detailForm.validateField('galleries')
      }
    },
    imageUpload(obj, form) {
      const formData = new FormData()
      formData.append('file', form.file)
      formData.append('name', form.file.name)
      formData.append('fileSize', form.file.size)
      formData.append('fileType', form.file.type)

      if (obj.key === 'cover') {
        this.coverImage.file = formData
      } else {
        const image = this.galleries.find(item => item.uid === form.file.uid)
        if (image) image.file = formData
        this.$refs.detailForm.validateField('galleries')
      }
    },
    imagePreview(obj, file) {
      const imageUrl = obj.key === 'cover' ? this.coverImage.url : file.url
      this.previewImg = imageUrl
      this.previewList = [imageUrl]
      this.$nextTick(() => this.$refs.elImage.clickHandler())
    },
    imageBeforeRemove(obj, file) {
      if (obj.key === 'cover') {
        this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' }).then(() => {
          this.imageRemove(obj, file)
        }).catch(() => {})
      } else {
        return this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' })
      }
    },
    imageRemove(obj, file) {
      if (obj.key === 'cover') {
        this.coverImage = Object.assign({}, { url: '', file: undefined })
        this.$refs.detailForm.validateField('cover')
      } else {
        const index = this.galleries.findIndex(item => item.uid === file.uid)
        this.galleries.splice(index, 1)
        this.$refs.detailForm.validateField('galleries')
      }
    },
    editorChange() {
      this.$refs.detailForm.validateField('planText')
    },
    uploadImages() {
      return new Promise((resolve, reject) => {
        const uploadPromises = []
        const files = this.galleries.filter(item => !!item.file)
        if (files && files.length) files.forEach(item => uploadPromises.push(uploadFile(item.file)))

        this.deletedImages.forEach(item => {
          const index = this.editorImages.findIndex(img => img.url === item.url)
          this.editorImages.splice(index, 1)
        })
        const editorFiles = this.editorImages.filter(item => !!item.file)
        if (editorFiles && editorFiles.length) editorFiles.forEach(item => uploadPromises.push(uploadFile(item.file)))

        if (this.coverImage.file) uploadPromises.push(uploadFile(this.coverImage.file))
        if (uploadPromises && uploadPromises.length) {
          Promise.all(uploadPromises).then(response => {
            const filesLength = (files && files.length) ? files.length : 0
            if (filesLength > 0) {
              files.forEach((item, index) => {
                const oIndex = this.galleries.findIndex(img => img.url === item.url)
                if (oIndex >= 0) {
                  item = Object.assign({}, item, { url: response[index], file: undefined })
                  this.galleries.splice(oIndex, 1, item)
                }
              })
            }

            if (editorFiles && editorFiles.length) {
              editorFiles.forEach((item, index) => {
                const oIndex = this.editorImages.findIndex(img => img.url === item.url)
                if (oIndex >= 0) {
                  item = Object.assign({}, item, { url: response[filesLength + index], file: undefined })
                  this.editorImages.splice(oIndex, 1, item)
                }
              })
            }
            this.editorImages.forEach(item => {
              this.detail.intro = `${this.detail.intro}`.replace(item.old, item.url)
            })
            if (this.coverImage.file) this.coverImage = { url: response[response.length - 1], file: undefined }
            resolve()
          }).catch(() => reject('图片上传失败'))
        } else {
          resolve()
        }
      })
    },
    addPromotion(e) {
      this.promotion = {
        id: undefined,
        goodsId: this.detail.id,
        isLimited: 1,                     // 是否限购
        quota: 1,                         // 限购数量
        deliveryTip: '购买后10天内发货',    // 发货提示
        startDate: this.$util.getToday(), // 开始时间
        endDate: undefined,               // 结束时间
        status: 0,                        // 状态：0 未开始 1 进行中 2 已结束
        volume: 0,                        // 销量
        retailPrice: this.detail.point,   // 促销价
        quantity: this.detail.quantity    // 促销数量
      }
      this.promoDialogTitle = '增加营销设置'
      this.promoDialogVisible = true
    },
    handleModify(e) {
      this.promotion = e.value
      this.promoDialogTitle = '编辑营销设置'
      this.promoDialogVisible = true
    },
    handleSubmit() {
      if (!this.promotion.startDate) {
        this.$confirm('没有设置开始日期，活动将会立即开始，是否确定？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.promotion.status = 1
          this.promotionOnSubmit()
        }).catch(() => {
          return false
        })
      } else {
        this.promotionOnSubmit()
      }
    },
    promotionOnSubmit() {
      this.$refs['promoForm'].validate(valid => {
        if (!valid) return false
        if (this.detail.promotions && this.promotions.length) {
          if (this.promotion.id) {
            this.detail.promotions = this.detail.promotions.map(item => item.id === this.promotion.id ? this.promotion : item)
          } else {
            this.detail.promotions.unshift(this.promotion)
          }
        } else {
          this.detail.promotions = [this.promotion]
        }

        this.promoDialogVisible = false
      })
    },
    onSubmit() {
      this.$refs.detailForm.validate(async(valid) => {
        if (!valid) return false

        this.loading = true
        // 上传商品图片
        this.uploadImages().then(() => {
          this.detail.cover = this.coverImage.url
          this.detail.galleries = this.galleries.map(item => item.url)

          delete this.detail.planText
          return saveGoods(this.detail)
        }).then(response => {
          this.$util.delay(500).then(() => {
            this.loading = false
            this.$confirm('商品资料保存成功，是否继续添加？', '温馨提示', {
              confirmButtonText: '继续添加',
              cancelButtonText: '返回列表',
              type: 'success'
            }).then(() => this.onCreateGoods()).catch(() => this.onBack())
          })
        }).catch(() => {
          this.$message.error('商品数据提交保存失败')
          this.loading = false
        })
      })
    },
    onCreateGoods() {
      this.galleries = []
      this.coverImage = {}
      this.editorImages = []
      this.deletedImages = []
      if (this.isCreate) {
        this.init()
      } else {
        this.$refs.detailForm.resetFields()
      }
    },
    onBack() {
      this.$store.dispatch('tagsView/delView', this.$route)
      const from = this.$route.query.from || ''
      if (from === 'list') {
        this.$router.go(-1)
      } else {
        this.$router.push({ path: `/goods/point/list` })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding-bottom: 50px;
}
.mobile .inline-form-item ::v-deep {
  .el-form-item__label {
    width: 85px;
  }
  .max-width {
    max-width: 100%;
  }
}
</style>
